<app-center-container
  [title]="title"
  [showClose]="false"
  [isLarge]="true"
  (close)="close()">

  <div class="home-wizard">
  <div class="wizard_progress">
    <span class="wizard_progress-label text--light">
      {{ 'step' | translate | titlecase }} {{ currentStep }} {{ 'of' | translate }} {{ totalSteps }}
    </span>
    <div class="wizard_progress-bar">
      <div class="wizard_progress-bar-fill" [style.width.%]="(currentStep / totalSteps) * 100"></div>
    </div>
  </div>

  <app-home-patient-step
    *ngIf="currentStep === 1"
    [initial]="patient"
    (next)="onPatientNext($event)">
  </app-home-patient-step>

  <app-home-device-step
    *ngIf="currentStep === 2"
    [initial]="device"
    (next)="onDeviceNext($event)"
    (back)="onDeviceBack()">
  </app-home-device-step>

  <app-home-network-step
    *ngIf="currentStep === 3"
    [initial]="network"
    (next)="onNetworkNext($event)"
    (back)="onNetworkBack()">
  </app-home-network-step>

  <app-home-review-step
    *ngIf="currentStep === 4"
    [patient]="patient"
    [device]="device"
    [network]="network"
    [isSubmitting]="isSubmitting"
    (submit)="onSubmit()"
    (back)="onReviewBack()">
  </app-home-review-step>

  <app-home-code-step
    *ngIf="currentStep === 5"
    [pairingCode]="pairingCode"
    [needsLinking]="deviceNeedsLinking"
    (done)="close()">
  </app-home-code-step>

  </div>
</app-center-container>
